import { render, staticRenderFns } from "./AdminsPagesContainer.vue?vue&type=template&id=4330dc42&"
import script from "./AdminsPagesContainer.vue?vue&type=script&lang=js&"
export * from "./AdminsPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports